export const labelsMapToOptions = <T extends PropertyKey>(map: Record<T, string>) => {
  const options: { label: string; value: T }[] = [];
  for (const [value, label] of Object.entries<string>(map)) {
    options.push({
      label,
      value: value as T,
    });
  }
  return options;
};
